<template>
    <div class="input-content">
        <div class="user-input-textarea-wrapper" ref="user-input-textarea-wrapper">
            <a-mentions
                rows="5"
                autoFocus
                v-model="prompt"
                :prefix="['/']"
                :disabled="typing"
                class="user-input-textarea" :placeholder="placeholder"
                @keydown.native.alt.enter.prevent="wrap"
                @select="selectValue"
                @blur="handleFocus(false)"
                @focus="handleFocus(true)"
                @keydown.native.enter.prevent.exact="ask"
                :getPopupContainer="() => $refs['user-input-textarea-wrapper']">
                <a-mentions-option :value="item.title" :key="item.value" v-for="item in mentionsList">
                    {{ item.title }}
                </a-mentions-option>
            </a-mentions>
        </div>
        <div class="textarea-right">
            <mic :prompt.sync="prompt"></mic>
            <img class="send" :class="{'disabled': !prompt}" src="@/theme/images/icons/icon_send.svg" @click="send()" title="发送" />
        </div>
    </div>
</template>

<script>
import commonApi from '@/api/common.api.js';
import yjyAPI from '@/api/yjy.api.js';
import ChatSocket from '@/socket/ChatSocket.js';
import mic from './mic.vue';
import MODEL_LIST from '@/app/constant/MODEL_LIST.js';
export default {
    name: 'gpt-chatbox-yjy-text2image',
    components: { mic },
    data () {
        return {
            prompt: '',
            MODEL_LIST
        };
    },
    props: {
        /**
         * 是否正在输入
         */
        typing: {
            type: Boolean,
            default: false
        },
        /**
         * 输入框的占位文字
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * 输入框的内容
         */
        input: {
            type: String,
            default: ''
        }
    },
    computed: {
        mentionsList () {
            return [
                ...this.MODEL_LIST
            ];
        }
    },
    watch: {
        input (val) {
            this.prompt = val;
        },
        prompt (val) {
            if (val && val[0] === '/') {
                this.$emit('showModel');
            }
            if (val && val.indexOf('/?') > -1) {
                this.$bus.$emit('openAiModel');
                this.prompt = this.prompt.replace('/?', '');
            }
        }
    },
    mounted () {
        this.prompt = this.input;
    },
    methods: {
        handleFocus (focus) {
            this.$emit('focus-typing', focus);
        },
        ask (event) {
            if (event && !event.altKey) {
                this.send();
            }
        },
        async send () {
            if (this.prompt.trim() === '') {
                this.$message.error('请输入内容后再发送');
                return;
            }
            try {
                let title = '以文生图';
                let input = this.prompt;
                this.$emit('askAnswerLoading', { title, input, answer: null, nospeech: true });

                let text = await this.translate(input);
                console.info(`原文：${input}\n译文：${text}`);

                // 生成图片
                let base64String = await yjyAPI.text2image_sd(text);

                // 上传图片，形成URL
                let fileName = Date.now() + '.png';
                let payload = {
                    'fileContent': base64String,
                    'fileContentType': '',
                    'fileName': fileName
                };

                // 图片URL
                let url = await commonApi.upload(payload);

                // 截取URL，去掉前面的域名
                if (url.indexOf('/llm/') >= 0) {
                    url = '/llm-files/' + url.substring(url.indexOf('/llm/') + 5);
                }

                let answer = `为您生成以下图片：\n![图片](${url})`;

                this.$emit('askAnswerFinish', { title, input, answer });
            } catch (err) {
                console.error(err);
            }
            this.prompt = '';
        },
        wrap (event) {
            if (event.altKey) {
                this.prompt = this.prompt + '\n';
            }
        },
        /**
         * 中文转英文
         */
        translate (text) {
            return new Promise((resolve, reject) => {
                let socket = new ChatSocket();
                socket.$on('done', (message) => {
                    resolve(message);
                    socket.close();
                });
                socket.$on('error', (err) => {
                    reject(err);
                });
                socket.$on('connected', () => {
                    let useLLM = this.$store.state.appSettings.useLLM;
                    let prompt = `请将下列中文内容翻译为英文（只输出翻译后的英文）:“${text}”。`;
                    let msg = { 'ask': prompt, 'useLLM': useLLM, 'type': 'TEXT' };
                    socket.send(msg);
                });
            });
        },
        selectValue (data) {
            this.$emit('setModel', data.value);
            this.prompt = this.prompt.replace(`/${data.value}`, '');
        }
    }
};
</script>

<style scoped lang="scss">
@import './gpt-chatbox-common.scss';

</style>
